import { inject, Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { catchError, of, switchMap, tap } from 'rxjs';
import { ExportUsersREQ } from '../../api';
import { EXPORT_ALL_USERS_FILENAME } from '../../constants';
import { translateExportUsersRes } from '../../utils/shared-translators';
import { SharedDataService } from '../data_services/shared.data.service';
import { extractCSVFileFromGZip } from '../../utils';

@Injectable({
  providedIn: 'root'
})
export class SharedUiService {
  #dataService = inject(SharedDataService);
  exportUsers(exportUsersReq: ExportUsersREQ) {
    return this.#dataService.exportUsers(exportUsersReq).pipe(
      switchMap((response) => extractCSVFileFromGZip(response)),
      tap((file) => saveAs(file, EXPORT_ALL_USERS_FILENAME)),
      catchError((err) => of(translateExportUsersRes(err)))
    );
  }
}
